import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import enUS from "./lang/enUS.json";

const i18NextOptions = {
  resources: {
    en: enUS
  },
  lng: "en",

  keySeparator: false,

  interpolation: {
    escapeValue: false
  }
};

i18n.use(initReactI18next).init(i18NextOptions);
